import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入 Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// 开发与生产均生效：全局修正包含双协议的图片地址，避免出现 https://domain/http://domain/...
;(function installGlobalImgUrlNormalizer() {
  const hasDoubleProto = url => /(https?:\/\/)[\s\S]*?(https?:\/\/)/i.test(url || '')
  const normalize = url => {
    if (!url) return url
    let raw = String(url).trim().replace(/^@+/, '')
    if (hasDoubleProto(raw)) {
      const lastHttp = raw.toLowerCase().lastIndexOf('http://')
      const lastHttps = raw.toLowerCase().lastIndexOf('https://')
      const lastIdx = Math.max(lastHttp, lastHttps)
      if (lastIdx > -1) raw = raw.slice(lastIdx)
    }
    return raw
  }

  const tryFixImg = img => {
    if (!img || img.tagName !== 'IMG') return
    const src = img.getAttribute('src')
    if (!src) return
    const fixed = normalize(src)
    if (fixed && fixed !== src) {
      img.setAttribute('src', fixed)
    }
  }

  // 初次遍历
  Array.prototype.forEach.call(document.images || [], tryFixImg)

  // 监听属性与子树变化
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.target && m.target.tagName === 'IMG' && m.attributeName === 'src') {
        tryFixImg(m.target)
      } else if (m.type === 'childList') {
        m.addedNodes && m.addedNodes.forEach(node => {
          if (node && node.tagName === 'IMG') tryFixImg(node)
          if (node && node.querySelectorAll) {
            node.querySelectorAll('img').forEach(img => tryFixImg(img))
          }
        })
      }
    }
  })
  observer.observe(document.documentElement || document.body, {
    attributes: true,
    attributeFilter: ['src'],
    subtree: true,
    childList: true,
  })
})()

/**
 * 忽略 ResizeObserver 的浏览器警告
 * 解决控制台出现：
 * "ResizeObserver loop completed with undelivered notifications"
 */
if (process.env.NODE_ENV === 'development') {
  // 兼容多种浏览器提示文案与不同类型（string/Error）的 reason
  const resizeObserverErr = /ResizeObserver loop (?:limit exceeded|completed with undelivered notifications)/i
  const matchesRO = msg => {
    if (!msg) return false
    const text = typeof msg === 'string' ? msg : (msg.message || String(msg))
    return resizeObserverErr.test(text)
  }
  window.addEventListener('error', e => {
    if (matchesRO(e && e.message)) {
      e.stopImmediatePropagation()
    }
  })
  window.addEventListener('unhandledrejection', e => {
    if (matchesRO(e && e.reason)) {
      e.preventDefault()
    }
  })
}

// 全局抑制 V2NIMError forbidden 在页面上展示（开发与生产均有效）
;(function installNimForbiddenSuppressor() {
  const nimForbidden = /(V2NIMError|forbidden)/i
  const matchesNim = input => {
    if (!input) return false
    if (typeof input === 'string') return nimForbidden.test(input)
    const text = input && (input.message || input.toString())
    return nimForbidden.test(text || '')
  }
  window.addEventListener('error', e => {
    if (matchesNim(e && e.error) || matchesNim(e && e.message)) {
      e.stopImmediatePropagation()
    }
  })
  window.addEventListener('unhandledrejection', e => {
    if (matchesNim(e && e.reason)) {
      e.preventDefault()
    }
  })
})()

// 抑制浏览器/扩展产生的“Could not establish connection. Receiving end does not exist”噪声
;(function suppressExtensionConnectError() {
  const re = /Could not establish connection\. Receiving end does not exist/i
  const hit = v => {
    if (!v) return false
    const t = typeof v === 'string' ? v : (v.message || v.reason || String(v))
    return re.test(t || '')
  }
  window.addEventListener('error', e => {
    if (hit(e && (e.error || e.message))) {
      e.stopImmediatePropagation()
    }
  })
  window.addEventListener('unhandledrejection', e => {
    if (hit(e && e.reason)) {
      e.preventDefault()
    }
  })
})()
